import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser';
import { gridColumnHeadingModel } from '../models/grid-column-heading-model';
import { AuditTrail, BulkSecurityInfo, SecurityData, SecurityInfo, SecurityReport, UserData, UserInput, UserSecurityDetailCriteria } from '../models/security-model';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';
import { MasterDataService } from '../services/masterdata.service';
import { SecurityService } from '../services/security.service';
import { UserRolesService } from '../services/user-roles.service';


@Component({
    selector: 'app-security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityComponent implements OnInit {
    allowRowCheckboxInGrid: boolean = false;
    totalRecord: number = 0;
    totalRecordNonRegGrid: number = 0;
    totalRecordRegGrid: number = 0;
    selectedcountriesdrp: any;
    selectedcountriesdrpLeft: any;
    countries: any;
    allCountries: any;
    selectedCountries: any;
    selectedCountryRows: any;
    selectedRows: any;
    nonRegisterArray = [];
    registerArray = [];
    checkedUncheckedMainGridData = [];
    selectedRoleId: number = 1;
    auditTrails: Array<AuditTrail> = [];
    roles: any;
    saveData: BulkSecurityInfo;
    saveCountryData: SecurityInfo;
    exportParams: SecurityReport;
    mainGridColumns: any;
    nonRegisterGridColumns: any;
    registerGridColumns: any;
    mainGridData: Array<SecurityData> = [];
    orgMainGridData:Array<SecurityData> = [];
    nonRegisterGridData = [];
    registerGridData = [];
    previewTextArea: string;
    emailidsArray: any;
    addNewOrDeact: number;
    selectedCountriesPopupIsActive: boolean = false;
    showLeftBtn: boolean = false;
    showRightBtn: boolean = false;
    showSaveDeactivateBtn: boolean = false;
    showCountryPopup: boolean = false;
    showCountryAdmin: boolean = false;
    showOtherOptions: boolean = false;
    showMainGrid: boolean = false;
    showNonRegisterGrid: boolean = false;
    showRegisterGrid: boolean = false;
    showPreview: boolean = false;
    disableEmailTextbox: boolean = false;
    disablePreviewBtn: boolean = true;
    disableSaveBtn: boolean = false;
    showCountryListValidation: boolean = false;
    showEmailIDValidation: boolean = false;
    showLoader: boolean = false;
    isExpandSearchFields: boolean = false;
    searchGridHeight: any;
    filterData: any;
    disableExport: boolean = false;
    showFacilitatorReportPopup: boolean = false;
    showAllUsersData: boolean = false;
    pageNumber = 1;
    pageSize = 50;
    userSecurityDetailCriteria: UserSecurityDetailCriteria =  new UserSecurityDetailCriteria();
    isCountryAdminModified: boolean = false;
    countryAdminOldIsActiveFlag: boolean = false;
    scrollTop: number = 0;
    contentAreaId: number = 0;

    constructor(private securityService: SecurityService, private _sanitizer: DomSanitizer, private masterDataService: MasterDataService, private render: Renderer2,
        private confirmationDialogService: ConfirmationDialogService, public userRoleService: UserRolesService) { }
    public uncheckedHtml: string = '<input class="checkboxmaingrid"  type="checkbox"></input>';
    public checkedHtml: string = '<input class="checkboxmaingrid"  checked type="checkbox"></input>';
    public disableCheckBoxHtml: string = '<input disabled type="checkbox"></input>';
    public editBtnHtml: string = '<input type="button" class="editbtnmaingrid" value="Edit"></input>';

    emailTextbox: string;
    selectedEmailIdCountryPopup: string;
    suggestions: any = [];

    userInput: UserInput;
    timeoutBool: any;
    checkOnint:number= 0;

    onKeydown(event) {
        const key = event.keyCode || event.charCode;
        if (key == 8) {
            this.selectedEmailIdCountryPopup = '';
        }
    }

    public timeoutFunction() {
        clearTimeout(this.timeoutBool);
        if (this.emailTextbox !== "") {

            this.userInput = { UserNameOrEmail: this.emailTextbox, };
            
            this.securityService.getEmailIdList(this.userInput).subscribe((res) => {
                console.log(res);
                this.suggestions = res;
                this.selectedEmailIdCountryPopup = "";
            });
        }
        else {
            this.suggestions = [];
        }
    }

    public suggestEmailId() {

        clearTimeout(this.timeoutBool);
        this.timeoutBool = setTimeout(() => { this.timeoutFunction() }, 800);



    }

    ngOnInit() {
        if (this.masterDataService.masterData != undefined) {
            this.countries = [];
            if (this.masterDataService.masterData?.Countries && this.masterDataService.masterData.Countries.length > 0) {  
               this.masterDataService.masterData.Countries.map(country => {  
                   if (country.ID !== 266) {  
                       this.countries.push({  
                           id: country.ID,  
                           name: country.Name,  
                           countryCode: country.CountryCode,  
                           countryCodeId: country.ID  
                       });  
                   }  
               });  
            }
        }
        else {
            this.masterDataService.getMasterDataDetails().subscribe((res) => {
                this.countries = [];
                if (this.masterDataService.masterData?.Countries && this.masterDataService.masterData.Countries.length > 0) {
                  this.masterDataService.masterData.Countries.map(country => {
                    if (country.ID !== 266) {
                      this.countries.push({
                        id: country.ID, name: country.Name,
                        countryCode: country.CountryCode, countryCodeId: country.ID
                      })
                    }
                    });
                    
                }
            })
        }
        
        this.autoPopulateOnTabChange();
        this.userRoleService.roleIdSubject.subscribe(data => {
            if (data === 3) {
                this.roles = [{
                    id: 1, name: 'All'
                },{
                        id: 2, name: 'Facilitator'
                }, {
                        id: 6, name: 'Subscription Administrator'
                    }];
            }
            else {
                this.roles = [{
                    id: 1, name: 'All'
                },{
                    id: 3, name: 'Country/Location Administrator'
                }, {
                    id: 2, name: 'Facilitator'
                }, {
                    id: 5, name: 'GX Facilitator'
                }, {
                    id: 6, name: 'Subscription Administrator'
                }, {
                    id: 8, name: 'XA (non-GX)'
                    }];
            }

            if (!this.selectedRoleId) {
                this.selectedRoleId = 1;                
            }
            if (this.checkOnint != 0)
                this.selectedRoleId = 1;
            if (this.selectedRoleId == 1)
                this.onChangeRole(this.selectedRoleId);
            this.setValuesToMasterDataObj();

            this.checkOnint += 1;
        });
        
    }
   
    //@ViewChild("searchFieldsHeight")
    //searchFieldsHeight: ElementRef;
    onResize(event) {
        alert('reize');
        if (!this.isExpandSearchFields) {
            this.searchGridHeightSet();
        } else {
          setTimeout(() => {
              
                const screenHeight = window.innerHeight;
                const totalDedVal = 100;
                this.searchGridHeight = (screenHeight - totalDedVal + "px");

                return (this.searchGridHeight);
            }, 300);
        }
    }

    searchGridHeightSet() {
        setTimeout(() => {
            const screenHeight = window.innerHeight;
            const totalDedVal = 230;
            this.searchGridHeight = (screenHeight - totalDedVal + "px");
            return (this.searchGridHeight);
        }, 300);
    }

    public onRightSwapClick() {
        for (let i = 0; i < this.selectedcountriesdrp.length; i++) {
            const countriesObj = this.allCountries.find(x => x.name == this.selectedcountriesdrp[i]);
            const index: number = this.allCountries.indexOf(countriesObj);
            if (index !== -1) {
                this.selectedCountries.push(countriesObj);
                this.allCountries.splice(index, 1); 
            }
        }
        if (this.selectedCountries.length > 0) {

            this.showCountryListValidation = false;
        }

    }
    public onLeftSwapClick() {
        for (let i = 0; i < this.selectedcountriesdrpLeft.length; i++) {
            const countriesObj = this.selectedCountries.find(x => x.name == this.selectedcountriesdrpLeft[i]);
            const index: number = this.selectedCountries.indexOf(countriesObj);
            if (index != -1) {
                this.selectedCountries.splice(index, 1);              
                this.allCountries.push(countriesObj);
            }
        }
    }
    public onSelectedEmailID(emailid, firstName, lastName) {
        this.emailTextbox = firstName + " " + lastName;
        this.selectedEmailIdCountryPopup = emailid;
        if (this.suggestions.length == 0) {
            this.showEmailIDValidation = true;
        } else {
            this.showEmailIDValidation = false;
        }
        this.suggestions = [];
    }
    public onSaveCountryPopup() {
        document.body.style.position = 'initial';
        const countryId: any = [];

        if (this.selectedEmailIdCountryPopup.length == 0) {
            this.showEmailIDValidation = true;
        } else {
            this.showEmailIDValidation = false;
        }
        if (this.selectedCountries.length == 0) {
            this.showCountryListValidation = true;
        } else {
            this.showCountryListValidation = false;
        }

        for (let i = 0; i < this.selectedCountries.length; i++) {
            countryId.push(this.selectedCountries[i].id)
        }

        if (this.showEmailIDValidation === false && this.showCountryListValidation === false) {

            this.saveCountryData = {
                RoleId: Number(this.selectedRoleId),
                Email: this.selectedEmailIdCountryPopup,
                IsActive: this.selectedCountriesPopupIsActive,
                CountryId: countryId,
                IsCountryAdminModified: (this.isCountryAdminModified || (this.countryAdminOldIsActiveFlag !== this.selectedCountriesPopupIsActive)) ? true : false
            }
            this.securityService.saveCountryDetails(this.saveCountryData).subscribe(res => {
                this.showCountryPopup = false;
                this.checkedUncheckedMainGridData = [];
                this.createMainGrid();
                this.showMainGrid = true;
                this.showPreview = false;
                this.isCountryAdminModified = false;
                this.selectedcountriesdrp=[];
                this.userRoleService.getUserRoles().subscribe(data => {
                    this.userRoleService.setUserRoleList(data.Roleid);
                });
            })
        }

    }

    public onCancelCountryPopup() {
        document.body.style.position = 'initial';
        this.showCountryPopup = false;
        this.selectedcountriesdrp=[];
    }

    public selectedLeftCountriesChange() {
        this.showLeftBtn = true;
        this.showRightBtn = false;
    }

    public selectedRightCountriesChange() {
        this.showLeftBtn = false;
        this.showRightBtn = true;
    }
    public createMainGrid() {
         if (this.selectedRoleId == 3) {
            this.mainGridColumns = [{
                name: "Name",
                header: "Name",
                dataType: "string",
                minWidth: "180px",
                isSearch:true,
            }, {
                name: "Title",
                header: "Level",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            }, {
                name: "Email",
                header: "Email",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            }, {
                name: "Country",
                header: "Country/Location",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            },
            {
                name: "ServiceFunction",
                header: "Function",
                dataType: "string",
                minWidth: "180px",
                isSearch: true
            },
            {
                name: "IsActive",
                header: "Active",
                dataType: "string",
                minWidth: "80px"
            },
            {
                name: "editSecurity",
                header: " ",
                dataType: "string",
                minWidth: "65px",
                marTop:"-10px"
            }];
        } else if(Number(this.selectedRoleId) == 1) {
            this.userRoleService.getUserRoleID().subscribe(userRoleId => {
                if(userRoleId === 1) {
                    this.mainGridColumns = [
                        {
                            name: "Name",
                            header: "Name",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Title",
                            header: "Level",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Email",
                            header: "Email",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Country",
                            header: "Country/Location",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "ServiceFunction",
                            header: "Function",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "CertificationlevelID",
                            header: "Certification Level",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "IsBC2",
                            header: "BC 2.0",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsFacilitator",
                            header: "Facilitator",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsGXFacilitator",
                            header: "GX Facilitator",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsXANonGX",
                            header: "XA (non-GX)",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsSubscriptionAdmin",
                            header: "Subscription Admin",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsCountryAdmin",
                            header: "Country Admin",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsActive",
                            header: "Active",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        }
                    ];
                } else {
                    this.mainGridColumns = [
                        {
                            name: "Name",
                            header: "Name",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Title",
                            header: "Level",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Email",
                            header: "Email",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        }, {
                            name: "Country",
                            header: "Country/Location",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "ServiceFunction",
                            header: "Function",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "CertificationlevelID",
                            header: "Certification Level",
                            dataType: "string",
                            minWidth: "150px",
                            isSearch: true,
                        },
                        {
                            name: "IsBC2",
                            header: "BC 2.0",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsFacilitator",
                            header: "Facilitator",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsSubscriptionAdmin",
                            header: "Subscription Admin",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        },
                        {
                            name: "IsActive",
                            header: "Active",
                            dataType: "string",
                            minWidth: "80px",
                            isSearch: false,
                        }
                    ];
                }
            });
        } else {
            this.mainGridColumns = [{
                name: "Name",
                header: "Name",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            }, {
                name: "Title",
                header: "Level",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            }, {
                name: "Email",
                header: "Email",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            }, {
                name: "Country",
                header: "Country/Location",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            },
            {
                name: "ServiceFunction",
                header: "Function",
                dataType: "string",
                minWidth: "180px",
                isSearch: true,
            },
            {
                name: "IsActive",
                header: "Active",
                dataType: "string",
                minWidth: "140px"
            }];
        }
        this.showLoader = true; 
        if(this.selectedRoleId == 1) {
             this.userSecurityDetailCriteria.PageSize = this.pageSize
            this.getAllSecurityUsersData();
        } else {
            this.getSecurityData();
        }
    }

    onFacilitatorReportClick() {
        // check if contentAreaId is not null
        this.showLoader = true;
        if (this.contentAreaId !== 0) {
          this.securityService.getFacilitatorReport(this.contentAreaId).subscribe(res => {
            const binaryData = [];
                binaryData.push(res);
                const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/vnd.ms-excel' }));
                // create hidden dom element (so it works in all browsers)
                const a = document.createElement('a');
                a.setAttribute('style', 'display:none;');
                document.body.appendChild(a);
                // create file, attach to hidden element and open hidden element
                a.href = url;
                a.download = `Report${this.contentAreaId}.xls`;
                a.click();
                this.showLoader = false;
            });
        }
    }

        /**
     * What: This function handle the server side pagination
     * When: This function will get called from grid component on click of pagination number
     * @param paginationObject have all details for pagination
     */
    updateListData(sortAndPageObj: any) {
        this.showLoader = true;
        this.pageNumber = 1;
        this.userSecurityDetailCriteria = sortAndPageObj.data as UserSecurityDetailCriteria;
        this.getAllSecurityUsersData();
        
    }

    public getAllSecurityUsersData(showloader?) {
        if (showloader == undefined) {
               this.showLoader = true;
        }
        this.pageNumber = 1;
        this.securityService.getAllSecurityUsersData(this.userSecurityDetailCriteria).subscribe((res: Array<SecurityData>) => {
            this.showLoader = false;
            this.mainGridData = res;
            this.orgMainGridData = res;
            if (this.mainGridData.length === 0) {
                this.disableExport = true;
            } else {
                this.disableExport = false;
            }
        });
    }

    public getAllSecurityUsersDataOnScroll() {
        this.showLoader = true;
        this.securityService.getAllSecurityUsersData(this.userSecurityDetailCriteria).subscribe((res: Array<SecurityData>) => {
            this.showLoader = false;
            this.mainGridData = [...this.mainGridData, ...res];
            this.orgMainGridData = [...this.orgMainGridData, ...res];
        });
    }

    public getSecurityData() {
        this.securityService.getSecurityData(this.selectedRoleId).subscribe((res: Array<SecurityData>) => {
            this.showLoader = false;
            this.mainGridData = res;
            this.orgMainGridData = res;
            this.totalRecord = this.mainGridData.length;
            this.searchGridHeightSet();
        });
    }

    public profileInfoSaved(event) {
        const grid = document.getElementById('gridScroll');

        if(grid) {
            grid.scrollTop=0
            this.userSecurityDetailCriteria.PageNumber = 1;
        }
        
        this.getAllSecurityUsersData();
    }

    onScroll(event): void {
        if(this.selectedRoleId == 1 && event.target.scrollTop != this.scrollTop) {
            const element = document.getElementById('gridScroll');
            const atBottom = (element.scrollHeight - Math.floor(element.scrollTop) >= element.clientHeight - 2 && 
                            element.scrollHeight - Math.floor(element.scrollTop) <= element.clientHeight + 2)
            if (atBottom) {
                this.userSecurityDetailCriteria.PageNumber += 1;
                this.getAllSecurityUsersDataOnScroll();
            } 
            this.scrollTop = event.target.scrollTop;
        }
    }

    public selectedRowData(row: SecurityData) {
        this.securityService.getAuditTrails(row.UserId).subscribe((res: Array<AuditTrail>) => {
            this.showLoader = false;
            this.auditTrails = res;
        });
    }

    public createRegisterGrid(data) {
        if (this.selectedRoleId == 2 || this.selectedRoleId == 6 || this.selectedRoleId == 8 || this.selectedRoleId == 5) {
            this.registerGridColumns = [{
                name: "Name",
                header: "Name",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Title",
                header: "Level",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Email",
                header: "Email",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Country",
                header: "Country/Location",
                dataType: "string",
                minWidth: "140px",
            },
            {
                name: "ServiceFunction",
                header: "Function",
                dataType: "string",
                minWidth: "140px"
            },
            {
                name: "IsActive",
                header: "Active",
                dataType: "string",
                minWidth: "140px"
            }];
        } else {
            this.registerGridColumns = [{
                name: "Name",
                header: "Name",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Title",
                header: "Level",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Email",
                header: "Email",
                dataType: "string",
                minWidth: "140px",
            }, {
                name: "Country",
                header: "Country/Location",
                dataType: "string",
                minWidth: "140px",
            },
            {
                name: "ServiceFunction",
                header: "Function",
                dataType: "string",
                minWidth: "140px"
            },
                //{
                //    name: "IsActive",
                //    header: "Active",
                //    dataType: "string",
                //    minWidth: "140px"
                //}
            ];
        }
        this.registerGridData = data;
        this.registerGridData.forEach((item) => {
            item.disabled = true;
        });
        this.totalRecordRegGrid = data.length;
        
    }

    public createNonRegisterGrid(data) {
        this.nonRegisterGridColumns = [{
            name: "Email",
            header: "Email",
            dataType: "string",
            minWidth: "140px",
        }, 
        {
            name: "Status",
            header: "Status",
            dataType: "string",
            minWidth: "140px",
        }];
        this.nonRegisterGridData = data;
        this.totalRecordNonRegGrid = data.length;
    }

    public onOtherOptionsAddNew() {
        this.showPreview = true;
        this.showMainGrid = false;
        this.addNewOrDeact = 2;
        this.registerArray = [];
        this.nonRegisterArray = [];
        this.createRegisterGrid(this.registerArray);
        this.createNonRegisterGrid(this.nonRegisterArray);
        this.previewTextArea = "";
        this.showSaveDeactivateBtn = false;
        this.showRegisterGrid = false;
        this.showNonRegisterGrid = false;
        this.disablePreviewBtn = true;
        this.setValuesToMasterDataObj();
    }

    public onOtherOptionsDeactivate() {
        this.showPreview = true;
        this.showMainGrid = false;
        this.addNewOrDeact = 3;
        this.registerArray = [];
        this.nonRegisterArray = [];
        this.createRegisterGrid(this.registerArray);
        this.createNonRegisterGrid(this.nonRegisterArray);
        this.previewTextArea = "";
        this.showSaveDeactivateBtn = false;
        this.showRegisterGrid = false;
        this.showNonRegisterGrid = false;
        this.disablePreviewBtn = true;
        this.setValuesToMasterDataObj();
    }

    public onExportAllSecurityDetail() {
        this.showLoader = true;
        const data = this.userSecurityDetailCriteria;
        const userSecurityDetailCriteria: UserSecurityDetailCriteria = {
            Name: data != undefined ? (data.Name.trim().length != 0 ? data.Name : "") : "",
            Level: data != undefined ? (data.Level.trim().length != 0 ? data.Level : "") : "",
            Email: data != undefined ? (data.Email.trim().length ? data.Email : "") : "",
            Location: data != undefined ? (data.Location.trim().length ? data.Location : "") : "",
            Function: data != undefined ? (data.Function.trim().length ? data.Function : "") : "",
            CertificationlevelID: data != undefined ? data.CertificationlevelID:null,
            SortBy: data != undefined ? (data.SortBy?.trim().length ? data.SortBy : "") : "",
            SortOrder: data != undefined ? (data.SortOrder?.trim().length ? data.SortOrder : "") : "",
            PageNumber: null,
            PageSize: null
        }

        this.securityService.getAllUserSecurityDetailExport(userSecurityDetailCriteria).subscribe(res => {
            const binaryData = [];
            binaryData.push(res);
            const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/vnd.ms-excel' }));
            // create hidden dom element (so it works in all browsers)
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            // create file, attach to hidden element and open hidden element
            a.href = url;
            a.download = "AllViewReport.xls";
            a.click();
            this.showLoader = false;
        }); 
    }

    public onExportClick() {
        this.showLoader = true;
        const data = this.filterData;
        this.exportParams = {
            RoleId: this.selectedRoleId,
            Name: data != undefined ? (data.Name?.trim()?.length != 0 ? data.Name : "") : "",
            Level: data != undefined ? (data.Title?.trim()?.length != 0 ? data.Title : "") : "",
            Email: data != undefined ? (data.Email?.trim()?.length ? data.Email : "") : "",
            Location: data != undefined ? (data.Country?.trim()?.length ? data.Country : "") : "",
            Function: data != undefined ? (data.ServiceFunction?.trim()?.length ? data.ServiceFunction : "") : "",
        }
        this.securityService.getExport(this.exportParams).subscribe(res => {
            const binaryData = [];
            binaryData.push(res);
            const url = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/vnd.ms-excel' }));
            // create hidden dom element (so it works in all browsers)
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            // create file, attach to hidden element and open hidden element
            a.href = url;
            const rolename = this.roles.find(x => x.id == this.selectedRoleId).name.toString().replace(/\s/g, "");
            a.download = rolename + "Report.xls";
            a.click();
            this.showLoader = false;
        });
    }

    public onPreviewTextAreaChange(event) {
        console.log(event.value);
        if (this.previewTextArea.length > 0) {
            this.disablePreviewBtn = false;
        }
        else {
            this.disablePreviewBtn = true;
        }
        this.setValuesToMasterDataObj();
    }

    public onPreviewBtnClick() {
        this.showSaveDeactivateBtn = true;
        this.emailidsArray = this.previewTextArea.split(",");
        console.log(this.emailidsArray);
        const defaultActionType = 2; // while fetching the preview data action type should be 2
        this.securityService.getPreview(this.previewTextArea, defaultActionType, this.selectedRoleId).subscribe(res => {
            this.registerArray = [];
            this.nonRegisterArray = [];
            console.log(res);
            for (let i = 0; i < res.length; i++) {
                if (res[i].Status !== "Deloitte User") {
                    this.nonRegisterArray.push({ "Email": res[i].Email, "Status": res[i].Status });
                }
                else {
                    this.registerArray.push(res[i]);
                    this.showSaveDeactivateBtn = true;
                }
            }
            this.disableSaveBtn = this.registerArray.length > 0 ? false : true;
            this.showNonRegisterGrid = true;
            this.showRegisterGrid = true;
            this.createRegisterGrid(this.registerArray);
            this.createNonRegisterGrid(this.nonRegisterArray);
            this.setValuesToMasterDataObj();
        })
    }
    isActiveCheckboxChange(data){
        this.registerGridData.find(x => x.Email == data[1].Email).IsActive = data[1].IsActive;
    }
    public onSavePreview() {
        const userData: UserData[] = [];

        for (let i = 0; i < this.registerGridData.length; i++) {
            userData.push({
                useremail: this.registerGridData[i].Email, isactive: this.registerGridData[i].IsActive??true
            })
        }

        this.saveData = {
            ActionType: this.addNewOrDeact,
            RoleId: Number(this.selectedRoleId),
            BulkUpdateUserFlag: userData
        }
        this.securityService.saveDetails(this.saveData).subscribe(res => {
            if ((this.saveData.ActionType === 2 || this.saveData.ActionType === 3 ) && this.saveData.RoleId === 5) {
                this.openConfirmationDialog();
            }
            else {
                this.checkedUncheckedMainGridData = [];
                this.createMainGrid();
                this.showMainGrid = true;
                this.showPreview = false;
            }
            this.setValuesToMasterDataObj();
            this.userRoleService.getUserRoles().subscribe(data => {
                this.userRoleService.setUserRoleList(data.Roleid);
            });
        })
        this.setValuesToMasterDataObj();
    }

    public openConfirmationDialog() {
        this.confirmationDialogService.confirm('Confirmation', 'GX Facilitator access has been saved.',
            'OK', null, 'sm', false, false)
            .then((confirmed) => {
                if (confirmed) {
                    this.checkedUncheckedMainGridData = [];
                    this.createMainGrid();
                    this.showMainGrid = true;
                    this.showPreview = false;
                    this.setValuesToMasterDataObj();
                }
            });
    }

    onUserRowSelect(event) {
        this.selectedRows = event.selected;
        if (this.selectedRows.length == 0)
            this.selectedRows = event.data;
    }

    public onAdminAddNew() {
        this.suggestions = [];
        this.showEmailIDValidation = false;
        this.showCountryListValidation = false;
        this.emailTextbox = "";
        this.selectedEmailIdCountryPopup = "";
        this.disableEmailTextbox = false;
        this.showCountryPopup = true;
        this.selectedCountries = [];
        this.allCountries = Array.from(this.countries);
        this.selectedCountriesPopupIsActive = false;
        this.isCountryAdminModified = true;
    }

    public onMainSave() {
        const userData: UserData[] = [];

        for (let i = 0; i < this.checkedUncheckedMainGridData.length; i++) {
            userData.push({
                useremail: this.checkedUncheckedMainGridData[i].Email, isactive: this.checkedUncheckedMainGridData[i].IsActive
            })
        }

        this.saveData = {
            ActionType: 1,
            RoleId: Number(this.selectedRoleId),
            BulkUpdateUserFlag: userData
        }
        this.securityService.saveDetails(this.saveData).subscribe(res => {
            this.checkedUncheckedMainGridData = [];
            this.createMainGrid();
            this.showMainGrid = true;
            this.showPreview = false;

            this.userRoleService.getUserRoles().subscribe(data => {
                this.userRoleService.setUserRoleList(data.Roleid);
            });
           
        })
    }

    public onMainCancel() {
        this.createMainGrid();
        this.checkedUncheckedMainGridData = [];
    }


    public onChangeRole(setvalue) { 
        this.showLoader = true;
        this.showAllUsersData = this.selectedRoleId == 1 ? true : false
        this.isClientSidePagination = this.selectedRoleId == 1 ? false : true;
        this.allowPagination = this.selectedRoleId == 1 ? false : true;
         this.mainGridData = [];
        this.orgMainGridData = [];
        this.filterData = {
          "Name": "",
          "Level": "",
          "Email": "",
          "Location": "",
          "Function": "",
          "CertificationlevelID": null,
          "SortBy": "",
          "SortOrder": "",
          "PageNumber": 1,
          "PageSize": 50
        }
        if (setvalue == 0) {
            this.mainGridData = [];
            this.mainGridColumns = [];
            this.showMainGrid = false;
            this.showPreview = false;
            this.checkedUncheckedMainGridData = [];
            this.showCountryAdmin = false;
            this.showOtherOptions = false;
            this.totalRecord = 0;
        }
        else {
            this.checkedUncheckedMainGridData = [];
            this.userSecurityDetailCriteria =  new UserSecurityDetailCriteria();
            this.createMainGrid();
            this.showMainGrid = true;
            this.showPreview = false;
            if (setvalue == 3) {
                this.showCountryAdmin = true;
                this.showOtherOptions = false;
            } else {
                this.showCountryAdmin = false;
                this.showOtherOptions = true;
            }
            this.searchGridHeightSet();
        }
        this.setValuesToMasterDataObj();

    }

    messageFromGridComponent: string = ""; //capturing the registered event from (child component) grid component

    // Below variables are for communication through grid and app component
    public allowCheckbox: boolean = false; //to display grid data with checkbox or not
    public iseventRegistered: boolean = false; //to register event on second column of grid or not
    public allowPagination: boolean = this.selectedRoleId === 1  ? false : true; //to display pagination or not
    public isClientSidePagination: boolean = this.selectedRoleId === 1  ? false : true; // clientside pagination or server side pagination

    // List of column/header for data grid
    public sampleColumns: gridColumnHeadingModel[];

    public sampleData = [];

    /**
     * What: This function handle the registerd event on second column of grid data
     * When: This function will get called from grid component on click of second columns items
     * @param message: Name of items of second column of data grid
     */
    parentWillTakeAction(message) {

        this.messageFromGridComponent = message;
    }

    checkboxClick(data) {
        if (this.checkedUncheckedMainGridData.length == 0) {
            this.checkedUncheckedMainGridData.push({ "Email": data[1].Email, "IsActive": data[0].target.checked });
        } else {
          const checkedObj = this.checkedUncheckedMainGridData.find(x => x.Email == data[1].Email);
            const index: number = this.checkedUncheckedMainGridData.indexOf(checkedObj);
            if (index === -1) {
                this.checkedUncheckedMainGridData.push({ "Email": data[1].Email, "IsActive": data[0].target.checked });
            }
            else {
                this.checkedUncheckedMainGridData.splice(index, 1);
            }
        }
    }
    editClick(data) {
        
        const userCountriesName = data.Country;
        this.selectedCountries = [];
        if (userCountriesName != null) {
          const userCountryDetails = userCountriesName.split("|");
          const existingCountries = [];
            for (let i = 0; i < userCountryDetails.length; i++) {
                const existingCountry = this.masterDataService.masterData.Countries.find(
                    (data) => data.Name == userCountryDetails[i].trim()
                );
                existingCountries.push(existingCountry);
            }

            existingCountries.map(country => {
                this.selectedCountries.push({
                    id: country.ID, name: country.Name,
                    countryCode: country.CountryCode, countryCodeId: country.ID
                })
            });
        }
        
        this.suggestions = [];
        this.showEmailIDValidation = false;
        this.showCountryListValidation = false;
        this.emailTextbox = data.Name;
        this.selectedEmailIdCountryPopup = data.Email;
        this.disableEmailTextbox = false;
        this.showCountryPopup = true;
        
        this.allCountries = Array.from(this.countries);
        this.selectedCountries.forEach(item => {
            const i = this.allCountries.findIndex(t => t.id == item.id);
            if(i > -1) {
                 this.allCountries.splice(i, 1)
            }
          });
        this.selectedCountriesPopupIsActive = data.IsActive;
        this.countryAdminOldIsActiveFlag = data.IsActive;
        document.body.style.position = 'sticky';
    }

    filterSecurityData(data) {

        const columnData = data.columnData;
        this.filterData = data.columnData;
        this.mainGridData = this.orgMainGridData;
        if (this.selectedRoleId == 1) {
            this.userSecurityDetailCriteria = data.columnData;
            this.getAllSecurityUsersData("noLoader");
        }
        else {
            this.mainGridData = this.mainGridData.filter(character => {
                return (columnData["Name"].trim().length > 0 ? (character["Name"] != null && character["Name"] != 'undefined' && character["Name"].length > 0 ? character["Name"].toLowerCase().includes(columnData["Name"].trim().toLowerCase()) : false) : true) &&
                    (columnData["Level"].trim().length > 0 ? (character["Title"] != null && character["Title"] != 'undefined' && character["Title"].length > 0 ? character["Title"].toLowerCase().includes(columnData["Level"].trim().toLowerCase()) : false) : true) &&
                    (columnData["Email"].trim().length > 0 ? (character["Email"] != null && character["Email"] != 'undefined' && character["Email"].length > 0 ? character["Email"].toLowerCase().includes(columnData["Email"].trim().toLowerCase()) : false) : true) &&
                    (columnData["Location"].trim().length > 0 ? (character["Country"] != null && character["Country"] != 'undefined' && character["Country"].length > 0 ? character["Country"].toLowerCase().includes(columnData["Location"].trim().toLowerCase()) : false) : true) &&
                    (columnData["Function"].trim().length > 0 ? (character["ServiceFunction"] != null && character["ServiceFunction"] != 'undefined' && character["ServiceFunction"].length > 0 ? character["ServiceFunction"].toLowerCase().includes(columnData["Function"].trim().toLowerCase()) : false) : true)

            });
        }
        if (this.mainGridData.length == 0) {
            this.disableExport = true;
        } else {
            this.disableExport = false;
        }

    }

    gotoTop() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    public onEmailTextboxBlur() {
        this.suggestions = [];
    }
    
    public autoPopulateOnTabChange() {

        const securityData = this.masterDataService.securityData;

        if (securityData) {
            this.selectedRoleId = securityData.selectedRoleId ? securityData.selectedRoleId : 0;
            this.onChangeRole(this.selectedRoleId);
            this.showMainGrid = securityData.showMainGrid ? securityData.showMainGrid : false;
            this.showCountryAdmin = securityData.showCountryAdmin ? securityData.showCountryAdmin : false;
            this.showOtherOptions = securityData.showOtherOptions ? securityData.showOtherOptions : false;
            this.previewTextArea = securityData.previewTextArea ? securityData.previewTextArea : "";
            this.showPreview = securityData.showPreview ? securityData.showPreview : false;
            this.disablePreviewBtn = securityData.disablePreviewBtn ? securityData.disablePreviewBtn : false;
            this.addNewOrDeact = securityData.addNewOrDeact ? securityData.addNewOrDeact : 0;
            this.showRegisterGrid = securityData.showRegisterGrid ? securityData.showRegisterGrid : false;
            this.showNonRegisterGrid = securityData.showNonRegisterGrid ? securityData.showNonRegisterGrid : false;
           

            
            this.createMainGrid();
           
            if (!this.disablePreviewBtn)
                this.onPreviewBtnClick();
        }
    }

    public setValuesToMasterDataObj() {
        const data = {
            selectedRoleId: this.selectedRoleId,
            showMainGrid: this.showMainGrid,
            showCountryAdmin: this.showCountryAdmin,
            showOtherOptions: this.showOtherOptions,
            previewTextArea: this.previewTextArea,
            showPreview: this.showPreview,
            disablePreviewBtn: this.disablePreviewBtn,
            addNewOrDeact: this.addNewOrDeact,
            showRegisterGrid: this.showRegisterGrid,
            showNonRegisterGrid: this.showNonRegisterGrid,
            //mainGridData: this.mainGridData,
            //nonRegisterGridData: this.nonRegisterGridData,
            //reg: this.registerGridData,
        }
        this.masterDataService.securityData = data;
    }
}


